import { call, put, takeLatest } from 'redux-saga/effects'
import { t } from 'i18next'
import apiCall from '../helpers/apiCall'
import { DELETE } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  DELETE_MOTORBIKE_PHOTO,
  DELETE_MOTORBIKE_PHOTO_FAILURE,
  DELETE_MOTORBIKE_PHOTO_SUCCESS
} from 'src/redux/photosReducer'
import { SHOW_TOAST } from 'src/redux/toastReducer'

interface DeleteMotorbikePhotoAction {
  payload: {
    motorbikeId: string
    photoId: string
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* DeleteMotorbikePhotoFlow(action: DeleteMotorbikePhotoAction): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    yield call(apiCall, {
      endpoint: `/dealers_api/motorbikes/${action.payload.motorbikeId}/photos/${action.payload.photoId}`,
      api: 'market-api',
      method: DELETE,
      params: {}
    })
    yield put(DELETE_MOTORBIKE_PHOTO_SUCCESS(action.payload.photoId))
    yield put(SHOW_TOAST({ message: t('my_vehicles.photo_deleted') }))
  } catch (error) {
    yield put(DELETE_MOTORBIKE_PHOTO_FAILURE())
    yield put(SHOW_TOAST({ message: t('my_vehicles.photo_upload_error') }))
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* DeleteMotorbikePhotoSaga(): Generator<any, void, any> {
  yield takeLatest(DELETE_MOTORBIKE_PHOTO, DeleteMotorbikePhotoFlow)
}
